export function fetchWizardDefinition({ name }) {
  const endpoint = `wizards/${name}`;
  return {
    endpoint,
    method: 'GET',
    requireAuth: true,
  };
}



// WEBPACK FOOTER //
// ./src/api/config/wizard.js